import script from "./product-variant.vue?vue&type=script&setup=true&lang=js"
export * from "./product-variant.vue?vue&type=script&setup=true&lang=js"

import "./product-variant.vue?vue&type=style&index=0&id=e953505e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e953505e"]])

export default __exports__